import { render, staticRenderFns } from "./m_pasar.vue?vue&type=template&id=2b0a01a6&scoped=true&"
import script from "./m_pasar.vue?vue&type=script&lang=js&"
export * from "./m_pasar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a01a6",
  null
  
)

export default component.exports